export default {
  // Common
  'sys.common.confirm': 'OK',
  'sys.common.cancel': 'Cancel',

  // User Management
  'sys.user.headerTitle': 'User Management',
  'sys.user.action.create': 'New User',
  'sys.user.action.resetPassword': 'Reset Password',
  'sys.user.action.view': 'View',
  'sys.user.action.edit': 'Edit',
  'sys.user.action.disable': 'Disable',
  'sys.user.action.enable': 'Enable',
  'sys.user.column.loginName': 'Username',
  'sys.user.column.name': 'Nickname',
  'sys.user.column.email': 'Email',
  'sys.user.column.phone': 'Phone',
  'sys.user.column.officeName': 'Department',
  'sys.user.column.isDepartmentHead': 'Department Head',
  'sys.user.isDepartmentHead.yes': 'Yes',
  'sys.user.isDepartmentHead.no': 'No',
  'sys.user.column.roleIds': 'Roles',
  'sys.user.column.loginFlag': 'Status',
  'sys.user.column.createdTime': 'Created Time',
  'sys.user.column.action': 'Action',
  'sys.user.status.enabled': 'Enabled',
  'sys.user.status.disabled': 'Disabled',
  'sys.user.confirm.disable.title': 'Are you sure to disable this user?',
  'sys.user.confirm.disable.description':
    'The user will not be able to log in after being disabled',
  'sys.user.confirm.enable.title': 'Are you sure to enable this user?',
  'sys.user.confirm.enable.description':
    'The user will be able to log in normally after being enabled',
  'sys.user.confirm.resetPassword.title':
    'Are you sure to reset the password for {count} selected users?',
  'sys.user.confirm.resetPassword.description':
    "The system will generate a random password and send it to the user's bound email",
  'sys.user.confirm.resetPassword.noEmailDescription':
    'The reset default password is: 123456',
  'sys.user.confirm.resetPassword.mixedDescription':
    '{usersWithEmailCount} selected users have bound emails and will receive random passwords by email; {usersWithoutEmailCount} users have no bound email and will be reset to default password: 123456',
  'sys.user.confirm.ok': 'OK',
  'sys.user.confirm.cancel': 'Cancel',
  'sys.user.message.disable.success': 'Disabled successfully',
  'sys.user.message.disable.failed': 'Failed to disable',
  'sys.user.message.enable.success': 'Enabled successfully',
  'sys.user.message.enable.failed': 'Failed to enable',
  'sys.user.message.batchDisable.success': 'Batch disabled successfully',
  'sys.user.message.batchDisable.failed': 'Failed to batch disable',
  'sys.user.message.resetPassword.warning':
    'Please select users to reset password',
  'sys.user.message.resetPassword.success':
    'Successfully reset passwords for {count} users',
  'sys.user.message.resetPassword.partial':
    'Processed {successCount} users successfully, but {failedCount} users failed. Please retry later',
  'sys.user.message.resetPassword.missingLoginName':
    'Selected users are missing login names and cannot be reset',
  'sys.user.message.resetPassword.failed': 'Failed to reset password',
  'sys.user.message.create.success': 'Created successfully',
  'sys.user.message.update.success': 'Updated successfully',
  'sys.user.message.getDetail.failed': 'Failed to get user details',
  'sys.user.message.getRoleList.failed': 'Failed to get role list',
  'sys.user.modal.create.title': 'New User',
  'sys.user.modal.edit.title': 'Edit User',
  'sys.user.modal.detail.title': 'User Details',
  'sys.user.modal.detail.close': 'Close',
  'sys.user.detail.label.loginName': 'Username',
  'sys.user.detail.label.name': 'Nickname',
  'sys.user.detail.label.status': 'Status',
  'sys.user.detail.label.email': 'Email',
  'sys.user.detail.label.phone': 'Phone',
  'sys.user.detail.label.officeName': 'Department',
  'sys.user.detail.label.roleIds': 'Roles',
  'sys.user.detail.label.createdTime': 'Created Time',
  'sys.user.detail.label.updatedTime': 'Updated Time',
  'sys.user.departmentTree.title': 'Department Filter',
  'sys.user.departmentTree.all': 'All Users',
  'sys.user.departmentTree.refresh': 'Refresh department tree',
  'sys.user.message.getOfficeTree.failed': 'Failed to load department tree',
  'sys.user.form.officeId.label': 'Department',
  'sys.user.form.officeId.placeholder': 'Select department',
  'sys.user.form.officeId.required': 'Please select a department',
  'sys.user.form.isDepartmentHead.label': 'Department Head',
  'sys.user.form.isDepartmentHead.placeholder': 'Please select',
  'sys.user.form.roleIds.label': 'Roles',
  'sys.user.form.roleIds.placeholder': 'Select roles',
  'sys.user.form.roleIds.required': 'Please select at least one role',
  'sys.user.form.loginFlag.label': 'Status',
  'sys.user.form.loginFlag.placeholder': 'Select status',

  // Dictionary Management
  'sys.dict.breadcrumb.root': 'Dictionary Management',
  'sys.dict.breadcrumb.rootDict': 'Root Dictionary',
  'sys.dict.headerTitle': 'Dictionary Management',
  'sys.dict.action.create': 'New Dictionary',
  'sys.dict.action.clearCache': 'Clear Cache',
  'sys.dict.action.batchDelete': 'Batch Delete',
  'sys.dict.action.config': 'Configuration',
  'sys.dict.action.edit': 'Edit',
  'sys.dict.action.view': 'View',
  'sys.dict.action.delete': 'Delete',
  'sys.dict.column.type': 'Dictionary Type',
  'sys.dict.column.label': 'Dictionary Name',
  'sys.dict.column.value': 'Dictionary Value',
  'sys.dict.column.langLabel': 'Multi-language',
  'sys.dict.column.description': 'Description',
  'sys.dict.column.sort': 'Sort',
  'sys.dict.column.action': 'Action',
  'sys.dict.confirm.delete.title': 'Confirm Delete',
  'sys.dict.confirm.delete.content':
    'Are you sure to delete dictionary "{label}"?',
  'sys.dict.confirm.batchDelete.title': 'Confirm Batch Delete',
  'sys.dict.confirm.batchDelete.content':
    'Are you sure to delete {count} selected dictionaries?',
  'sys.dict.confirm.clearCache.title': 'Confirm Clear Cache',
  'sys.dict.confirm.clearCache.content':
    'Are you sure to clear all dictionary cache?',
  'sys.dict.message.delete.success': 'Deleted successfully',
  'sys.dict.message.delete.failed': 'Failed to delete',
  'sys.dict.message.batchDelete.warning':
    'Please select dictionaries to delete',
  'sys.dict.message.batchDelete.success': 'Batch deleted successfully',
  'sys.dict.message.batchDelete.failed': 'Failed to batch delete',
  'sys.dict.message.clearCache.success': 'Cache cleared successfully',
  'sys.dict.message.clearCache.failed': 'Failed to clear cache',
  'sys.dict.message.create.success': 'Dictionary created successfully',
  'sys.dict.message.create.failed': 'Failed to create dictionary',
  'sys.dict.message.update.success': 'Dictionary updated successfully',
  'sys.dict.message.update.failed': 'Failed to update dictionary',
  'sys.dict.message.multiLang.success': 'Multi-language configuration saved',
  'sys.dict.modal.detail.title': 'Dictionary Details',
  'sys.dict.modal.create.title': 'New Dictionary',
  'sys.dict.modal.edit.title': 'Edit Dictionary',
  'sys.dict.modal.config.title': '{dict} - Dictionary Configuration',
  'sys.dict.config.column.label': 'Label',
  'sys.dict.config.column.value': 'Value',
  'sys.dict.config.column.langLabel': 'Multi-language Label',
  'sys.dict.message.config.notFound':
    'No corresponding dictionary type configuration was found',
  'sys.dict.message.config.loadFailed':
    'Failed to load dictionary configuration',
  'sys.dict.form.type.label': 'Dictionary Type',
  'sys.dict.form.type.placeholder': 'Please enter dictionary type',
  'sys.dict.form.type.required': 'Please enter dictionary type',
  'sys.dict.form.type.maxLength':
    'Dictionary type cannot exceed 100 characters',
  'sys.dict.form.label.label': 'Dictionary Name',
  'sys.dict.form.label.placeholder': 'Please enter dictionary name',
  'sys.dict.form.label.required': 'Please enter dictionary name',
  'sys.dict.form.label.maxLength':
    'Dictionary name cannot exceed 100 characters',
  'sys.dict.form.value.label': 'Dictionary Value',
  'sys.dict.form.value.placeholder': 'Please enter dictionary value',
  'sys.dict.form.value.required': 'Please enter dictionary value',
  'sys.dict.form.value.maxLength':
    'Dictionary value cannot exceed 100 characters',
  'sys.dict.form.sort.label': 'Sort',
  'sys.dict.form.sort.placeholder': 'Please enter sort value',
  'sys.dict.form.multiLang.label': 'Multi-language Configuration',
  'sys.dict.form.multiLang.button': 'Configure Multi-language',
  'sys.dict.form.description.label': 'Description',
  'sys.dict.form.description.placeholder': 'Please enter description',
  'sys.dict.form.description.maxLength':
    'Description cannot exceed 500 characters',
  'sys.dict.form.submit.create': 'Create',
  'sys.dict.form.submit.update': 'Update',
  'sys.dict.form.submit.cancel': 'Cancel',
  'sys.dict.multiLang.modal.title': 'Multi-language Configuration',
  'sys.dict.multiLang.modal.ok': 'Save',
  'sys.dict.multiLang.modal.cancel': 'Cancel',
  'sys.dict.multiLang.action.add': 'Add language configuration',
  'sys.dict.multiLang.select.placeholder': 'Select language',
  'sys.dict.multiLang.input.placeholder':
    'Please enter value for this language',
  'sys.dict.multiLang.language.zh': 'Simplified Chinese',
  'sys.dict.multiLang.language.en': 'English',
  'sys.dict.multiLang.message.keepOne':
    'At least one language configuration must be kept',
  'sys.dict.multiLang.message.fillAllValues':
    'Please complete values for all language configurations',
  'sys.dict.multiLang.message.duplicateLanguage':
    'Duplicate language configurations found, please check',
  'sys.dict.itemForm.modal.create.title': 'New Dictionary Item',
  'sys.dict.itemForm.modal.edit.title': 'Edit Dictionary Item',
  'sys.dict.itemForm.label.required': 'Please enter label',
  'sys.dict.itemForm.label.placeholder': 'Please enter label',
  'sys.dict.itemForm.label.maxLength':
    'Label length cannot exceed 100 characters',
  'sys.dict.itemForm.value.required': 'Please enter value',
  'sys.dict.itemForm.value.placeholder': 'Please enter value',
  'sys.dict.itemForm.value.maxLength':
    'Value length cannot exceed 100 characters',
  'sys.dict.itemForm.multiLang.button': 'Configure multi-language label',
  'sys.dict.itemForm.message.sortFallback':
    'Failed to fetch sort value, using default value',
  'sys.dict.itemForm.message.create.success': 'Created successfully',
  'sys.dict.itemForm.message.create.failed': 'Failed to create',
  'sys.user.title': 'User Management',
  'sys.role.title': 'Role Management',
  'sys.menu.title': 'Menu Management',
  'sys.dict.title': 'Dictionary Management',
  'sys.upload.title': 'File Management',

  // Role Management
  'sys.role.headerTitle': 'Role Management',
  'sys.role.action.create': 'New Role',
  'sys.role.action.view': 'View',
  'sys.role.action.edit': 'Edit',
  'sys.role.action.auth': 'Authorization',
  'sys.role.action.delete': 'Delete',
  'sys.role.column.name': 'Role Name',
  'sys.role.column.enname': 'English Name',
  'sys.role.column.roleType': 'Role Code',
  'sys.role.column.sort': 'Sort',
  'sys.role.column.officeName': 'Department',
  'sys.role.column.remarks': 'Description',
  'sys.role.column.useable': 'Status',
  'sys.role.column.action': 'Action',
  'sys.role.status.enabled': 'Enabled',
  'sys.role.status.disabled': 'Disabled',
  'sys.role.confirm.delete.title': 'Are you sure to delete this role?',
  'sys.role.confirm.batchDelete.title':
    'Are you sure to batch delete selected roles?',
  'sys.role.message.delete.success': 'Deleted successfully',
  'sys.role.message.delete.failed': 'Failed to delete',
  'sys.role.message.batchDelete.success': 'Batch deleted successfully',
  'sys.role.message.batchDelete.failed': 'Failed to batch delete',
  'sys.role.message.create.success': 'Created successfully',
  'sys.role.message.update.success': 'Updated successfully',
  'sys.role.message.auth.success': 'Authorization successful',
  'sys.role.modal.create.title': 'New Role',
  'sys.role.modal.edit.title': 'Edit Role',
  'sys.role.modal.detail.title': 'Role Details',
  'sys.role.modal.auth.title': 'Role Menu Authorization',
  'sys.role.detail.label.name': 'Role Name',
  'sys.role.detail.label.enname': 'English Name',
  'sys.role.detail.label.roleType': 'Role Code',
  'sys.role.detail.label.sort': 'Sort',
  'sys.role.detail.label.officeName': 'Department',
  'sys.role.detail.label.useable': 'Status',
  'sys.role.detail.label.remarks': 'Description',
  'sys.role.table.alert.selected': 'Selected',
  'sys.role.table.alert.items': 'items',
  'sys.role.table.alert.deselect': 'Deselect',
  'sys.role.table.alert.batchDelete': 'Batch Delete',
  'sys.role.form.name.label': 'Role Name',
  'sys.role.form.name.placeholder': 'Please enter role name',
  'sys.role.form.name.required': 'Please enter role name',
  'sys.role.form.name.length': 'Role name length should be 2-50 characters',
  'sys.role.form.enname.label': 'English Name',
  'sys.role.form.enname.placeholder': 'Please enter English name',
  'sys.role.form.enname.required': 'Please enter English name',
  'sys.role.form.enname.length':
    'English name length should be 2-50 characters',
  'sys.role.form.sort.label': 'Sort',
  'sys.role.form.sort.placeholder': 'Please enter sort value',
  'sys.role.form.sort.required': 'Please enter sort value',
  'sys.role.form.sort.pattern': 'Sort value must be a positive integer',
  'sys.role.form.officeId.label': 'Department',
  'sys.role.form.officeId.placeholder': 'Please select department',
  'sys.role.form.officeId.required': 'Please select department',
  'sys.role.form.useable.label': 'Status',
  'sys.role.form.useable.placeholder': 'Please select status',
  'sys.role.form.useable.required': 'Please select status',
  'sys.role.form.useable.enabled': 'Enabled',
  'sys.role.form.useable.disabled': 'Disabled',
  'sys.role.form.remarks.label': 'Description',
  'sys.role.form.remarks.placeholder': 'Please enter role description',
  'sys.role.form.submit.create': 'Create',
  'sys.role.form.submit.update': 'Update',
  'sys.role.form.submit.cancel': 'Cancel',
  'sys.role.message.create.failed': 'Failed to create',
  'sys.role.message.update.failed': 'Failed to update',
  'sys.role.message.getOfficeTree.failed': 'Failed to get department tree',
  'sys.role.auth.label.name': 'Role Name: ',
  'sys.role.auth.label.menu': 'Menu Permissions: ',
  'sys.role.auth.message.incomplete': 'Role information is incomplete',
  'sys.role.auth.message.failed': 'Failed to save',
  'sys.role.auth.message.getMenuTree.failed': 'Failed to get menu data',
  'sys.role.auth.message.getRoleMenuIds.failed':
    'Failed to get role menu permissions',
  'sys.role.auth.button.cancel': 'Cancel',
  'sys.role.auth.button.save': 'Save',

  // Menu Management
  'sys.menu.headerTitle': 'Menu Management',
  'sys.menu.action.create': 'New Menu',
  'sys.menu.action.createChild': 'New',
  'sys.menu.action.edit': 'Edit',
  'sys.menu.action.view': 'View',
  'sys.menu.action.delete': 'Delete',
  'sys.menu.column.name': 'Menu Name',
  'sys.menu.column.enName': 'English Name',
  'sys.menu.column.type': 'Type',
  'sys.menu.column.icon': 'Icon',
  'sys.menu.column.href': 'Link',
  'sys.menu.column.hrefOrPermission': 'Link/Permission',
  'sys.menu.column.permission': 'Permission',
  'sys.menu.column.isShow': 'Display',
  'sys.menu.column.sort': 'Sort',
  'sys.menu.column.action': 'Action',
  'sys.menu.type.menu': 'Menu',
  'sys.menu.type.button': 'Button',
  'sys.menu.status.show': 'Show',
  'sys.menu.status.hide': 'Hide',
  'sys.menu.confirm.delete.title': 'Are you sure to delete this menu?',
  'sys.menu.message.delete.success': 'Deleted successfully',
  'sys.menu.message.delete.failed': 'Failed to delete',
  'sys.menu.message.batchDelete.success': 'Batch deleted successfully',
  'sys.menu.message.batchDelete.failed': 'Failed to batch delete',
  'sys.menu.message.create.success': 'Created successfully',
  'sys.menu.message.create.failed': 'Failed to create menu',
  'sys.menu.message.update.success': 'Updated successfully',
  'sys.menu.message.update.failed': 'Failed to update menu',
  'sys.menu.modal.create.title': 'New Menu',
  'sys.menu.modal.edit.title': 'Edit Menu',
  'sys.menu.modal.detail.title': 'Menu Details',
  'sys.menu.form.name.label': 'Menu Name',
  'sys.menu.form.name.placeholder': 'Please enter menu name',
  'sys.menu.form.name.required': 'Please enter menu name',
  'sys.menu.form.enName.label': 'English Name',
  'sys.menu.form.enName.placeholder': 'Please enter English name',
  'sys.menu.form.parentMenu.label': 'Parent Menu',
  'sys.menu.form.parentMenu.placeholder': 'Please select parent menu',
  'sys.menu.form.parentMenu.required': 'Please select parent menu',
  'sys.menu.form.parentMenu.tip':
    'You can select any level menu as parent menu',
  'sys.menu.form.icon.label': 'Icon',
  'sys.menu.form.icon.placeholder': 'Please enter or select icon',
  'sys.menu.form.path.label': 'Route Address',
  'sys.menu.form.path.placeholder': 'Please enter route address',
  'sys.menu.form.perms.label': 'Permission',
  'sys.menu.form.perms.placeholder': 'Please enter permission',
  'sys.menu.form.perms.query': 'Query',
  'sys.menu.form.perms.add': 'Add',
  'sys.menu.form.perms.edit': 'Edit',
  'sys.menu.form.perms.delete': 'Delete',
  'sys.menu.form.status.label': 'Display',
  'sys.menu.form.status.show': 'Show',
  'sys.menu.form.status.hide': 'Hide',
  'sys.menu.form.sort.label': 'Sort',
  'sys.menu.form.sort.required': 'Please enter sort value',
  'sys.menu.form.message.noUrl':
    'Unable to get menu URL, please ensure parent menu is selected correctly',
  'sys.menu.detail.label.name': 'Menu Name',
  'sys.menu.detail.label.enName': 'English Name',
  'sys.menu.detail.label.type': 'Type',
  'sys.menu.detail.label.icon': 'Icon',
  'sys.menu.detail.label.href': 'Link',
  'sys.menu.detail.label.permission': 'Permission',
  'sys.menu.detail.label.isShow': 'Display',
  'sys.menu.detail.label.sort': 'Sort',
  'sys.menu.detail.label.remarks': 'Remarks',

  // File Upload Management
  'sys.upload.headerTitle': 'File Management',
  'sys.upload.action.upload': 'Upload File',
  'sys.upload.action.refresh': 'Refresh',
  'sys.upload.action.copy': 'Copy',
  'sys.upload.action.delete': 'Delete',
  'sys.upload.column.name': 'File Name',
  'sys.upload.column.type': 'Type',
  'sys.upload.column.size': 'Size',
  'sys.upload.column.lastModified': 'Modified Time',
  'sys.upload.column.action': 'Action',
  'sys.upload.type.file': 'File',
  'sys.upload.type.folder': 'Folder',
  'sys.upload.bucket.label': 'Bucket:',
  'sys.upload.bucket.data': 'data',
  'sys.upload.bucket.public': 'public',
  'sys.upload.tree.title': 'Directory Structure',
  'sys.upload.tree.root': 'Root Directory',
  'sys.upload.table.title': 'Current Directory:',
  'sys.upload.table.total': 'Total {total} files',
  'sys.upload.modal.title': 'Upload File',
  'sys.upload.modal.uploadTo': 'Upload to:',
  'sys.upload.modal.dragHint': 'Click or drag files to this area to upload',
  'sys.upload.modal.dragHintSub': 'Support single or batch file upload',
  'sys.upload.modal.uploading': 'Uploading...',
  'sys.upload.confirm.delete.title': 'Confirm Delete',
  'sys.upload.confirm.delete.content':
    'Are you sure to delete file "{fileName}"?',
  'sys.upload.message.delete.success': 'File deleted successfully',
  'sys.upload.message.delete.failed': 'Failed to delete file',
  'sys.upload.message.upload.success': 'File uploaded successfully',
  'sys.upload.message.upload.failed': 'Failed to upload file',
  'sys.upload.message.copy.success': 'Access address copied to clipboard',
  'sys.upload.message.copy.failed': 'Copy failed, please copy manually',
  'sys.upload.message.getFiles.failed': 'Failed to get file list',
  'sys.upload.message.initTree.failed': 'Failed to initialize directory tree',
  'sys.upload.message.getViewUrl.failed':
    'Failed to get preview address configuration',

  // Department Management
  'sys.department.title': 'Department Management',
  'sys.department.headerTitle': 'Department Management',
  'sys.department.action.create': 'New Department',
  'sys.department.action.createChild': 'New',
  'sys.department.action.edit': 'Edit',
  'sys.department.action.auth': 'Auth',
  'sys.department.action.view': 'View',
  'sys.department.action.delete': 'Delete',
  'sys.department.column.officeName': 'Department Name',
  'sys.department.column.officeCode': 'Department Code',
  'sys.department.column.type': 'Type',
  'sys.department.column.leader': 'Department Leader',
  'sys.department.column.sortNo': 'Sort',
  'sys.department.column.isActive': 'Status',
  'sys.department.column.action': 'Action',
  'sys.department.type.company': 'Company',
  'sys.department.type.department': 'Department',
  'sys.department.status.enabled': 'Enabled',
  'sys.department.status.disabled': 'Disabled',
  'sys.department.confirm.delete.title':
    'Are you sure to delete this department?',
  'sys.department.message.create.success': 'Created successfully',
  'sys.department.message.create.failed': 'Failed to create department',
  'sys.department.message.update.success': 'Updated successfully',
  'sys.department.message.update.failed': 'Failed to update department',
  'sys.department.message.auth.success':
    'Menu authorization saved successfully',
  'sys.department.message.delete.success': 'Deleted successfully',
  'sys.department.message.delete.failed': 'Failed to delete department',
  'sys.department.message.getDetail.failed': 'Failed to get department detail',
  'sys.department.modal.create.title': 'New Department',
  'sys.department.modal.edit.title': 'Edit Department',
  'sys.department.modal.auth.title': 'Department Menu Authorization',
  'sys.department.modal.detail.title': 'Department Detail',
  'sys.department.detail.label.officeName': 'Department Name',
  'sys.department.detail.label.officeCode': 'Department Code',
  'sys.department.detail.label.type': 'Type',
  'sys.department.detail.label.sortNo': 'Sort',
  'sys.department.detail.label.isActive': 'Status',
  'sys.department.detail.label.remarks': 'Remarks',
  'sys.department.form.parent.label': 'Parent Department',
  'sys.department.form.parent.placeholder': 'Please select parent department',
  'sys.department.form.parent.required': 'Please select parent department',
  'sys.department.form.parent.topLevel': 'Top Level',
  'sys.department.form.officeName.label': 'Department Name',
  'sys.department.form.officeName.placeholder': 'Please enter department name',
  'sys.department.form.officeName.required': 'Please enter department name',
  'sys.department.form.officeCode.label': 'Department Code',
  'sys.department.form.officeCode.placeholder': 'Please enter department code',
  'sys.department.form.officeCode.required': 'Please enter department code',
  'sys.department.form.type.label': 'Type',
  'sys.department.form.type.placeholder': 'Please select type',
  'sys.department.form.type.required': 'Please select type',
  'sys.department.form.sortNo.label': 'Sort',
  'sys.department.form.sortNo.placeholder': 'Please enter sort number',
  'sys.department.form.sortNo.required': 'Please enter sort number',
  'sys.department.form.isActive.label': 'Status',
  'sys.department.form.isActive.placeholder': 'Please select status',
  'sys.department.form.leader.label': 'Department Leader',
  'sys.department.form.leader.placeholder': 'Please select department leader',
  'sys.department.form.remarks.label': 'Remarks',
  'sys.department.form.remarks.placeholder': 'Please enter remarks',
  'sys.department.auth.label.name': 'Department Name: ',
  'sys.department.auth.label.menu': 'Menu Permissions: ',
  'sys.department.auth.hint.company':
    'Company permissions will be bound to the CEO role',
  'sys.department.auth.message.incomplete':
    'Department information is incomplete',
  'sys.department.auth.message.failed': 'Failed to save',
  'sys.department.auth.message.getMenuTree.failed': 'Failed to load menu tree',
  'sys.department.auth.message.getOfficeMenuIds.failed':
    'Failed to load department menu permissions',
  'sys.department.auth.button.cancel': 'Cancel',
  'sys.department.auth.button.save': 'Save',
  'sys.department.auth.button.checkAll': 'Select All',
  'sys.department.auth.button.uncheckAll': 'Deselect All',
  'sys.manualHanding.title': 'Manual Handling',
  'sys.manualHanding.bankSync.cardTitle': 'Bank Statement Sync',
  'sys.manualHanding.bankSync.assetTable.label': 'Repayment Type',
  'sys.manualHanding.bankSync.assetTable.placeholder':
    'Please select repayment type',
  'sys.manualHanding.bankSync.assetTable.mortgage': 'Mortgage Repayment',
  'sys.manualHanding.bankSync.assetTable.car': 'Parking Repayment',
  'sys.manualHanding.bankSync.action.sync': 'Sync',
  'sys.manualHanding.bankSync.message.selectFirst':
    'Please select a repayment type first',
  'sys.manualHanding.bankSync.message.success':
    'Sync task submitted and is running. Please check later',
  'sys.manualHanding.bankSync.message.failed': 'Sync failed',
  'sys.manualHanding.todoCache.cardTitle': 'Todo Overview Cache',
  'sys.manualHanding.todoCache.description':
    'Recalculate and refresh billing, booking, and repair todo counts',
  'sys.manualHanding.todoCache.action.refresh': 'Force Refresh',
  'sys.manualHanding.todoCache.message.success':
    'Todo overview cache refreshed successfully',
  'sys.manualHanding.todoCache.message.failed':
    'Failed to refresh todo overview cache',

  // Video Menu Binding
  'sys.videoMenu.title': 'Video Tutorial Configuration',
  'sys.videoMenu.selectMenuFirst': 'Please select menu first',
  'sys.videoMenu.loadingConfig': 'Loading video server configuration...',
  'sys.videoMenu.configNotFound': 'Video server configuration not found',
  'sys.videoMenu.bindedVideos': 'Bound Videos',
  'sys.videoMenu.addVideo': 'Add Video',
  'sys.videoMenu.editVideo': 'Edit Video',
  'sys.videoMenu.selectVideos': 'Select Videos',
  'sys.videoMenu.availableVideos': 'Available Videos',
  'sys.videoMenu.selectedVideos': 'Selected Videos',
  'sys.videoMenu.column.title': 'Video Title',
  'sys.videoMenu.column.path': 'Video Path',
  'sys.videoMenu.column.sort': 'Sort',

  // Common messages
  'sys.common.fetchFailed': 'Failed to fetch data',
  'sys.common.bindSuccess': 'Bind successfully',
  'sys.common.bindFailed': 'Failed to bind',
  'sys.common.deleteSuccess': 'Deleted successfully',
  'sys.common.deleteFailed': 'Failed to delete',
  'sys.common.deleteConfirm': 'Are you sure to delete?',
  'sys.common.updateSuccess': 'Updated successfully',
  'sys.common.updateFailed': 'Failed to update',
  'sys.common.noData': 'No data',
  'sys.common.preview': 'Preview',
  'sys.common.edit': 'Edit',
  'sys.common.delete': 'Delete',
  'sys.common.action': 'Action',
  'sys.common.selectMenuFirst': 'Please select menu first',
};
